import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import { up } from '@Globals/Style/breakpoints'

export interface ChipProps {
  color?: 'grey' | 'red'
  fadedBackground?: boolean
  fontWeight?: 'normal' | 'bold'
  size?: 'small' | 'medium'
  uppercase?: boolean
}

const StyledChip = styled.div<ChipProps>`
  display: inline-block;
  line-height: 1;
  font-weight: ${({ fontWeight }) => fontWeight};
  ${({ uppercase }) => uppercase && css`
    text-transform: uppercase;
  `}
  border: 1px solid ${({ color, theme }) => (
    color === 'grey'
      ? theme.colors.greyDark
      : theme.colors.red
  )};
  color: ${({ color, theme }) => (
    color === 'grey'
      ? theme.colors.greyDark
      : theme.colors.red
  )};
  ${({ fadedBackground }) => fadedBackground && css`
    background-color: rgba(245, 245, 245, 0.35);
  `}
  ${({ size }) => (
    size === 'small'
      ? css`
        padding: 5px 5px 4px;
        font-size: 0.665rem;

        ${up('phablet')} {
          font-size: 0.75rem;
        }
      `
      : css`
        padding: 5px 10px;
        font-size: 1rem;
      `
  )}
`

export const Chip: FC<ChipProps> = (
  {
    children,
    color = 'grey',
    fadedBackground = false,
    fontWeight = 'normal',
    size = 'small',
    uppercase = false,
  },
) => (
  <StyledChip
    color={color}
    fadedBackground={fadedBackground}
    fontWeight={fontWeight}
    size={size}
    uppercase={uppercase}
  >
    {children}
  </StyledChip>
)
